import { DateObject } from "react-multi-date-picker";
import { UpdatePeakSurcharge } from "../../ratecard/dtos/UpdateRateCardRequest";
import {
  ClientInvoicePeakSurchargeUIRequest,
  EditClientInvoiceUIRequest,
} from "../ClientInvoiceInterfaces";
import { convertStringToDateTime } from "../../../../components/common/utils/DateUtils";
import {
  CiRouteEditReponse,
  RouteResponse,
  TripAndDateRangeDataForSelectedStores,
} from "../../../../app/models/responseModels/ClientInvoiceResponses";
import { Theme } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { CLIENT_INVOICE_STATUS } from "../ClientInvoiceConstants";
import { formatDateTime } from "../../ratecard/utils/PeakSurchargeUtils";

export const getInvoiceStatusCellColour = (
  invoiceStatus: string,
  theme: Theme
): string => {
  if (invoiceStatus === CLIENT_INVOICE_STATUS.DRAFT)
    return theme.palette.warning.main;
  else if (invoiceStatus === CLIENT_INVOICE_STATUS.REJECTED)
    return theme.palette.error.main;
  else return theme.palette.success.main;
};

function safeFormatDate(input: any, fallback = new Date()) {
  if (!input) return fallback; // Return fallback if input is null or undefined
  
  // Check if input is a valid Date object or a Date-like object
  if (typeof input.toDate === 'function') {
    const date = input.toDate();
    return date instanceof Date ? date : fallback; // Ensure the result is a Date
  }

  // If it's already a Date, return it, otherwise attempt to convert the input
  return input instanceof Date ? input : new Date(input) instanceof Date ? new Date(input) : fallback;
}


export const mapPeakSurchargeToUiRequest = (
  peakSurchargeList: UpdatePeakSurcharge[] | undefined
): ClientInvoicePeakSurchargeUIRequest[] => {
  console.log("🔍 Debug: Received peakSurchargeList =>", peakSurchargeList);

  if (!Array.isArray(peakSurchargeList)) {
    console.error("❌ Error: peakSurchargeList is undefined or not an array", peakSurchargeList);
    return []; // Return an empty array to prevent forEach errors
  }

  let uiRequestList: ClientInvoicePeakSurchargeUIRequest[] = [];

  peakSurchargeList.forEach((surcharge, index) => {
    const minDate = safeFormatDate(surcharge.peakSurchargeMinDate);
    const maxDate = safeFormatDate(surcharge.peakSurchargeMaxDate);

    console.log(`✅ Peak Surcharge ${index + 1} Dates:`, { minDate, maxDate });

    let uiItem: ClientInvoicePeakSurchargeUIRequest = {
      peakSurchargeId: surcharge.peakSurchargeId ?? undefined,
      peak_surcharge_date_range:
        minDate instanceof Date && maxDate instanceof Date
          ? [new DateObject({ date: minDate }), new DateObject({ date: maxDate })]
          : [],
      peakSurchargeType: surcharge.peakSurchargeType,
      peak_surcharge_value_percentage:
        surcharge.peakSurchargeType === "percentage" ? surcharge.peakSurchargeValue : undefined,
      peak_surcharge_value_dollar:
        surcharge.peakSurchargeType === "value" ? surcharge.peakSurchargeValue : undefined,
    };

    uiRequestList.push(uiItem);
  });

  return uiRequestList.length > 0
    ? uiRequestList
    : [
        {
          peakSurchargeType: null,
          peak_surcharge_date_range: [],
          peak_surcharge_value_dollar: undefined,
          peak_surcharge_value_percentage: undefined,
        },
      ];
};









// this checks if the route data is really edited(changed) or not
export const isRouteEdited = (
  uiRequest: EditClientInvoiceUIRequest,
  originalRoute: RouteResponse,
  editRoute: CiRouteEditReponse | undefined
) => {
  if (editRoute)
    return (
      uiRequest.totalOrders !== editRoute.totalOrders ||
      uiRequest.ordersDelivered !== editRoute.ordersDelivered ||
      uiRequest.ordersUndelivered !== editRoute.ordersUndelivered ||
      uiRequest.ordersUndeliveredNoAttempt !==
        editRoute.ordersUndeliveredNoAttempt
    );
  return (
    uiRequest.totalOrders !== originalRoute.totalOrders ||
    uiRequest.ordersDelivered !== originalRoute.ordersDelivered ||
    uiRequest.ordersUndelivered !== originalRoute.ordersUndelivered ||
    uiRequest.ordersUndeliveredNoAttempt !==
      originalRoute.ordersUndeliveredNoAttempt
  );
};

export const getMinOrMaxDate = (dateList: Dayjs[], getMinDate: boolean) => {
  if (dateList.length === 0) return null;
  let result = dateList[0];
  dateList.forEach((date) => {
    if (getMinDate && date.isBefore(result)) result = date;
    else if (!getMinDate && date.isAfter(result)) result = date;
  });

  return result;
};

export const filterRoutesOnDateRange = (
  data: TripAndDateRangeDataForSelectedStores[],
  startDate: Dayjs,
  endDate: Dayjs
): RouteResponse[] => {
  const routeList = data
    .filter((item) => {
      const date = dayjs(item.date);
      if (startDate) {
        if (date.isBefore(startDate)) return false;
      }
      if (endDate) {
        if (date.isAfter(endDate)) return false;
      }
      return true;
    })
    .map((item) => item.route);

  return routeList;
};
